/**
 * Load the repositories, this action starts the request saga
 *
 * @return {object} An action object with a type of LOAD_REPOS
 */
import {
  SAVE_FORM_DATA_SUCCESS,
  SAVE_FORM_DATA_FAIL,
  SAVE_FORM_DATA,
  SUBMIT_CLAIM,
  SUBMIT_CLAIM_SUCCESS,
  SUBMIT_CLAIM_FAIL,
  UPLOAD_CLAIM_SUMMARY,
  GET_BANK,
  GET_BANK_ERROR,
  GET_BANK_SUCCESS,
  GETTING_BANK,
  DOWNLOAD_CLAIM_SUMMARY,
  EMAIL_ME_DOCUMENTS,
} from './constants';

export function saveFormData() {
  return {
    type: SAVE_FORM_DATA,
  };
}

export function saveFormDataSuccess() {
  return {
    type: SAVE_FORM_DATA_SUCCESS,
  };
}

export function saveFormDataFail(error) {
  return {
    type: SAVE_FORM_DATA_FAIL,
    error,
  };
}

export function submitClaim() {
  return {
    type: SUBMIT_CLAIM,
  };
}

export function uploadClaimSummary(blob) {
  return {
    type: UPLOAD_CLAIM_SUMMARY,
    blob,
  };
}

export function submitClaimSuccess() {
  return {
    type: SUBMIT_CLAIM_SUCCESS,
  };
}

export function submitClaimFail(error) {
  return {
    type: SUBMIT_CLAIM_FAIL,
    error,
  };
}

export function getBank(bsb) {
  return {
    type: GET_BANK,
    bsb,
  };
}

export function getBankError() {
  return {
    type: GET_BANK_ERROR,
  };
}

export function getBankSuccess(bankInfo) {
  return {
    type: GET_BANK_SUCCESS,
    bankInfo,
  };
}

export function gettingBank(value) {
  return {
    type: GETTING_BANK,
    value,
  };
}
export function downloadClaimSummaryPdf(cb) {
  return {
    type: DOWNLOAD_CLAIM_SUMMARY,
    cb,
  };
}
export function emailMeDocument() {
  return {
    type: EMAIL_ME_DOCUMENTS,
  };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/actions.js